import angular, { ILogService } from 'angular'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { BloqueForm } from '../../../data/bloque-form'
import { PreguntaForm } from '../../../data/pregunta-form'

class TarjetaPregBloqueComponentCtrl {
  pregbloque!: PreguntaForm
  bloque!: BloqueForm
  idx!: number

  editando = false

  constructor(
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[TarjetaPregBloqueComponentCtrl] onInit')
  }

  editPreguntaFormulario() {
    this.editando = true
  }

  toggleVisiblePreguntaFormulario() {
    this.pregbloque.toggleVisible()
  }

  toggleEliminarPreguntaFormulario() {
    this.pregbloque.toggleEliminar()
  }

  downPregFormulario() {
    this.bloque.bajarPreg(this.idx)
  }

  upPregFormulario() {
    this.bloque.subirPreg(this.idx)
  }

  nuevaOpcion() {
    this.pregbloque.options.push('')
  }

  splitOpcion(idx: number) {
    this.pregbloque.options.splice(idx, 1)
  }
}

angular.module('candidato').component('tarjetaPregBloque', {
  bindings: {
    pregbloque: '<',
    bloque: '<',
    idx: '<',
  },
  controller: TarjetaPregBloqueComponentCtrl,
  template: require('./tarjeta-preg-bloque.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-preg-bloque/tarjeta-preg-bloque.component.html"
})
